import React from 'react'
import BankChangeApprovalSummary from './BankChangeApprovalSummary'
import BankChangeDecisionForm from './BankChangeDecisionForm'
import AccountOverviewCard from './AccountOverviewCard'
import TransactionAnalysisTable from './TransactionAnalysisTable'
import TransactionHistoryTable from './TransactionHistoryTable'
import ExpenseBreakdownTable from './ExpenseBreakdownTable'
import DebitCardSignalsTable from './DebitCardSignalsTable'

const ChirpResultsContent = ({
  requestCode,
  success,
  accounts,
  selectedAccount,
  accountOptions,
  selectedAccountIndex,
  onAccountChange,
  bankChange,
  managerApproval,
  bankChangeManagerStatus,
  customerData,
  oldAccountLastFour,
  oldAccountRouting,
  hasManagerApprovalReadPermission,
  hasManagerApprovalUpdatePermission,
  normalizedAnalysis,
  transactionAnalysisSort,
  setTransactionAnalysisSort,
  expandedTransactionAnalysis,
  toggleTransactionAnalysis,
  normalizedTransactions,
  transactionHistorySort,
  setTransactionHistorySort,
  expandedTransactionHistory,
  toggleTransactionHistory,
  normalizedExpenses,
  expenseBreakdownSort,
  setExpenseBreakdownSort,
  expandedExpenseBreakdown,
  toggleExpenseBreakdown,
  debitCardEnrichment,
  bankChangeStatus,
  setBankChangeStatus,
  bankChangeReason,
  setBankChangeReason,
  isSubmitting,
  canSubmitBankChangeDecision,
  onSubmitBankChangeDecision,
}) => (
  <div className="lox-detail mt-3">
    {bankChange && hasManagerApprovalReadPermission && (
      <BankChangeApprovalSummary
        status={bankChangeManagerStatus}
        customerData={customerData}
        oldAccountLastFour={oldAccountLastFour}
        oldAccountRouting={oldAccountRouting}
      />
    )}

    <div className="box mb-4 ml-2 mr-2">
      <div className="is-flex is-justify-content-space-between is-align-items-center is-flex-wrap-wrap">
        <div>
          <p className="mb-1"><strong>Request Code:</strong> {requestCode || '-'}</p>
          <p className="mb-1"><strong>Accounts Found:</strong> {accounts.length}</p>
        </div>
        <span className={`tag is-large has-text-weight-bold ${success ? 'is-success' : 'is-danger'}`}>
          {success ? 'Success' : 'Failed'}
        </span>
      </div>
    </div>

    {accounts.length > 0 && (
      <AccountOverviewCard
        selectedAccount={selectedAccount}
        accountOptions={accountOptions}
        selectedAccountIndex={selectedAccountIndex}
        onAccountChange={onAccountChange}
      />
    )}

    {normalizedAnalysis.length > 0 && (
      <TransactionAnalysisTable
        data={normalizedAnalysis}
        expanded={expandedTransactionAnalysis}
        onToggle={toggleTransactionAnalysis}
        sortState={transactionAnalysisSort}
        setSortState={setTransactionAnalysisSort}
      />
    )}

    {normalizedTransactions.length > 0 && (
      <TransactionHistoryTable
        data={normalizedTransactions}
        expanded={expandedTransactionHistory}
        onToggle={toggleTransactionHistory}
        sortState={transactionHistorySort}
        setSortState={setTransactionHistorySort}
      />
    )}

    {normalizedExpenses.length > 0 && (
      <ExpenseBreakdownTable
        data={normalizedExpenses}
        expanded={expandedExpenseBreakdown}
        onToggle={toggleExpenseBreakdown}
        sortState={expenseBreakdownSort}
        setSortState={setExpenseBreakdownSort}
      />
    )}

    {debitCardEnrichment.length > 0 && (
      <DebitCardSignalsTable data={debitCardEnrichment} />
    )}

    {managerApproval && bankChange && hasManagerApprovalUpdatePermission && (
      <BankChangeDecisionForm
        customerData={customerData}
        oldAccountLastFour={oldAccountLastFour}
        oldAccountRouting={oldAccountRouting}
        showDecisionControls={bankChangeManagerStatus === 'pending'}
        bankChangeStatus={bankChangeStatus}
        setBankChangeStatus={setBankChangeStatus}
        bankChangeReason={bankChangeReason}
        setBankChangeReason={setBankChangeReason}
        isSubmitting={isSubmitting}
        canSubmit={canSubmitBankChangeDecision}
        onSubmit={onSubmitBankChangeDecision}
      />
    )}
  </div>
)

export default ChirpResultsContent
